import React, { Component } from 'react';
import classNames from 'classnames';
import Checkbox from '../../../forms/checkbox';
import { applySegmentFilter } from '../../helpers/filter-helpers';

class SegmentGroup extends Component {
    
    constructor(props) {
        super(props);
        this.state = {
            checked: props.selected,
            isVisible: false
        }
    }

    componentDidMount() {
        this.props.registerSegmentGroupComponent(this);
    }

    handleChange() {
        this.setState({
            checked: !this.state.checked
        }, () => {
            this.props.toggleAllChildren(this.props.typeGroupCode, this.state.checked);
        });
    }

    toggleVisible() {
        this.setState({
            isVisible: !this.state.isVisible
        });
    }

    reset() {
        this.setState({
            checked: true
        });
    }

    render() {
        return (
            <li>
                <label>
                    <Checkbox type="checkbox" 
                            checked={this.state.checked} 
                            onChange={() => this.handleChange()} /> {this.props.typeGroupName}
                </label>
                <button className={classNames({
                    'map-filters__chain-toggler': true,
                    'map-filters__chain-toggler--is-open': this.state.isVisible
                })} type="button" onClick={() => this.toggleVisible()}></button>
                <Segment {...this.props} isVisible={this.state.isVisible} />
            </li>
        );
    }
}

class Segment extends Component {

    render() {

        return (
            <ul className={classNames({
                'map-filters__chain': true,
                'map-filters__chain--is-visible': this.props.isVisible
            })}>
                {this.props.segments.filter(({ typeGroupCode }) => typeGroupCode === this.props.typeGroupCode).map((segment, i) => {
                    return (
                        <li key={`${segment.typeCode}${i}`}>
                            <label>
                                <Checkbox type="checkbox" checked={segment.selected} onChange={() => this.props.toggleSelected(segment.typeCode, !segment.selected)} /> {segment.typeName}
                            </label>
                        </li>
                    );
                })}
            </ul>
        );
    }
}

class Segments extends Component {

    segmentGroupComponents = [];
    state = {
        segments: null,
        segmentGroups: null
    };

    registerSegmentGroupComponent(comp) {
        this.segmentGroupComponents.push(comp);
    }

    isSegmentGroupSelected(segments, typeGroupCode) {
        return segments.find(segment => segment.selected && segment.typeGroupCode === typeGroupCode ? true : false) ? true : false;
    }

    getSegmentGroups(segments) {
        const groups = [];

        segments.forEach(group => {
            if (!groups.find(g => g.typeGroupCode === group.typeGroupCode)) {
                groups.push({
                    typeGroupName: group.typeGroupName,
                    typeGroupCode: group.typeGroupCode,
                    selected: this.isSegmentGroupSelected(segments, group.typeGroupCode)
                });
            }
        });
        
        return groups;
    }
    
    toggleAllChildren(typeGroupCode, selected) {
        const segments = this.state.segments.map(segment => {
            if (typeGroupCode === segment.typeGroupCode) {
                return {
                    ...segment,
                    selected
                }
            }
            
            return segment;
        });

        this.setState({
            segments
        }, () => {
            this.props.previewFilter();
        });
    }

    toggleSelected(typeCode, selected) {
        const segments = this.state.segments.map(segment => {
            if (typeCode === segment.typeCode) {
                return {
                    ...segment,
                    selected
                }
            }

            return segment;
        });
        
        this.setState({
            segments
        }, () => {
            this.props.previewFilter();
        });
    }

    filter(units) {
        const segments = this.state.segments || this.props.filters.segments;
        const filteredUnits = applySegmentFilter(units, segments, this.props.type);
        return {
            filteredUnits, 
            filter: {
                segments
            }
        };
    }

    componentDidMount() {
        const { filters } = this.props;

        this.setState({
            segments: filters.segments,
            segmentGroups: this.getSegmentGroups(filters.segments)
        }, () => {
            this.props.registerFilter(this);
        });
    }

    reset() {
        const segments = this.state.segments.map(segment => {
            return ({
                ...segment,
                selected: true
            });
        });

        const typeGroups = this.state.typeGroups.map(group => {
            return ({
                ...group,
                selected:true
            });
        });

        this.setState({
            segments,
            typeGroups
        }, (() => {
            this.segmentGroupComponents.forEach(segmentGroupComp => {
                segmentGroupComp.reset();
            });
        }));
    }

    getPropertyName() {
        return this.props.propertyName;
    }

    getValues() {
        return this.state.segments;
    }

    render() {

        const { segments, segmentGroups } = this.state;

        return (
            <div className="map-filters__filter">
                <h2 className="map-filters__filter-heading">Segment</h2>
                <ul className="map-filters__chains">
                    {segmentGroups && segmentGroups.map(g => {
                        return (
                            <SegmentGroup {...g} 
                                        registerSegmentGroupComponent={(comp) => this.registerSegmentGroupComponent(comp)}
                                        segments={segments} 
                                        toggleSelected={(typeCode, selected) => this.toggleSelected(typeCode, selected)}
                                        toggleAllChildren={(typeGroupCode, selected) => this.toggleAllChildren(typeGroupCode, selected)} 
                                        key={g.typeGroupCode} />
                        );
                    })}
                </ul>
            </div>
        );
    }
};

export default Segments;